export class BusinessInterventionError extends Error {
    constructor(message, isWarning) {
        super(message);
        this.businessInterventionError = true;
        this.isWarning = isWarning;
    }
}
